import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    form: FormGroup;
    error;

    constructor(private fb: FormBuilder, private authService: AuthService, private router: Router) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            email: [null, [Validators.required, Validators.email]],
            password: [null, Validators.required]
        });
    }

    login() {
        this.authService.login(this.form.getRawValue()).then(res => this.router.navigateByUrl('events')).catch(err => this.error = err.message);
    }

}
